export default __webpack_public_path__ + "static/media/copy.5d931b04.svg";